import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Container } from 'react-bootstrap';
import { slide as Menu } from 'react-burger-menu';
import { useCatalogo } from '../services/catalogo';
import logo from '../assets/logo.png';
import '../styles/header-footer.scss';

function Header() {
    const [aberto, setAberto] = useState(false);
    const catalogo = useCatalogo();
    const links = catalogo?.indice?.links || [];
    const fechar = () => setAberto(false);

    return (
        <header className="hdr">
            <Container>
                <div className="hdr__topo">
                    <Link to="/" className="hdr__marca" onClick={fechar}>
                        <img src={logo} className="hdr__logo" alt="Prefeitura de Duas Barras" />
                        <div className="hdr__nome">
                            <span className="hdr__label">Prefeitura de Duas Barras — RJ</span>
                            <p className="hdr__titulo">Secretaria de Meio Ambiente</p>
                        </div>
                    </Link>
                </div>
            </Container>

            <Menu right isOpen={aberto} onStateChange={(s) => setAberto(s.isOpen)}>
                <Link className="menu-item menu-item--destaque" to="/" onClick={fechar}>
                    Início
                </Link>
                <Link className="menu-item" to="/busca" onClick={fechar}>Buscar documentos</Link>
                <div className="menu-sep" />
                {links.map((l) => (
                    <a
                        key={l.url}
                        className="menu-item"
                        href={l.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        onClick={fechar}
                    >
                        {l.titulo}
                    </a>
                ))}
                {links.length > 0 && <div className="menu-sep" />}
                <a className="menu-item" href="https://duasbarras.rj.gov.br">Site da Prefeitura</a>
                <a className="menu-item" href="https://duasbarras.rj.gov.br/transparencia">
                    Portal da Transparência
                </a>
            </Menu>
        </header>
    );
}

export default Header;
